<footer class="footer-light d-md-block d-none" >
  <app-footer-news-letter [newsLetterStyle]="'basic'"></app-footer-news-letter>
  <section class="section-b-space light-layout">
    <div class="container">
      <div class="row footer-theme g-sm-4 g-2">
        <div class="col-xl-3 col-lg-4 col-md-6">
          <div class="footer-content h-auto">
            <app-footer-logo [logo]="logo"></app-footer-logo>
            <app-footer-about [data]="data"></app-footer-about>
            @if(data?.footer?.social_media_enable){
              <app-footer-social-links [data]="data"></app-footer-social-links>
            }
          </div>
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-md-6" (click)="toggle('categories')">
          <div class="sub-title">
            <div class="footer-title" [class.show]="active['categories']">
              <h4>{{ 'categories' | translate }}</h4>
            </div>
            <div class="footer-content">
              <app-footer-categories [categoryIds]="data?.footer?.footer_categories || []"></app-footer-categories>
              <!-- No Data -->
              <app-no-data [class]="'no-data-footer'" [text]="'no_category_found'" *ngIf="!data?.footer?.footer_categories?.length"></app-no-data>
            </div>
          </div>
        </div>
        <div class="col-xl col-lg-2 col-md-3" (click)="toggle('useful_link')">
          <div class="sub-title">
            <div class="footer-title" [class.show]="active['useful_link']">
              <h4>{{ 'useful_links' | translate }}</h4>
            </div>
            <div class="footer-content">
              <app-footer-links [links]="data?.footer?.useful_link || []"></app-footer-links>
              <!-- No Data -->
              <app-no-data [class]="'no-data-footer'" [text]="'no_link_found'" *ngIf="!data?.footer?.useful_link?.length"></app-no-data>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-md-3" (click)="toggle('help_center')">
          <div class="sub-title">
            <div class="footer-title" [class.show]="active['help_center']">
              <h4>{{ 'help_center' | translate }}</h4>
            </div>
            <div class="footer-content">
              <app-footer-links [links]="data?.footer?.help_center || []"></app-footer-links>
              <!-- No Data -->
              <app-no-data [class]="'no-data-footer'" [text]="'no_link_found'" *ngIf="!data?.footer?.help_center?.length"></app-no-data>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6" (click)="toggle('contact')">
          <div class="sub-title">
            <div class="footer-title" [class.show]="active['contact']">
              <h4>{{ 'store_information' | translate }}</h4>
            </div>
            <div class="footer-content">
              <app-footer-contact [data]="data" [class]="'contact-list'"></app-footer-contact>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="sub-footer">
    <div class="container">
      <div class="row">
        @if(data?.footer?.footer_copyright){
          <div class="col-xl-6 col-md-6 col-sm-12">
            <app-footer-copyright [data]="data"></app-footer-copyright>
          </div>
        }
        @if(data?.footer?.payment_option_image_url){
          <div class="col-xl-6 col-md-6 col-sm-12">
            <div class="payment-card-bottom">
              <app-footer-payment-options [data]="data"></app-footer-payment-options>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</footer>
